<div class="sign-in-required">
  <h2 class="mb-3">Connexion requise</h2>
  <p>Vous devez être connecté pour laisser un commentaire.</p>

  <div class="d-flex justify-content-end mt-4">
    <button class="btn btn-outline-secondary me-2" (click)="close()">Annuler</button>
    <button class="btn connexion" (click)="goToLogin()">Se connecter</button>
  </div>

</div>
